// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailA":"A_d2xDetailA__C0AOT"};